<template xmlns="http://www.w3.org/1999/html">
  <div class="container">
<div class="elrow" v-loading="loading">
    <el-card shadow="always" class="card-box">
      <div class="top">
        <div class="top-inner">
          <div>Message(s) can be viewed within 24 hours. </div>
          <div>Note: Charges apply for replying message.</div>
        </div>
      </div>

      <div class="msgcontainer">
        <div class="msgcontainer-inner" ref="msgcontainerInnser">
          <div v-for="item of msg">
            <div style="font-size: 12px; color: darkgray; margin-bottom: 10px">
              {{ item.time }}
            </div>
            <div v-if="item.isRight" style="text-align: right">
              <div class="message-wrapper message-wrapper-right">
                <div class="message-content-wrapper message-content-wrapper-right">
                  <div class="message-content">
                    <div v-if="item.msg" class="wechat-bubble">{{ item.msg }}</div>
                    <div v-if="item.sos">
                      <img src="../../assets/sos.jpeg" class="sosright"/>
                    </div>
                    <div v-if="item.positionPic">
                      <img
                          :src="item.positionPic"
                          class="position-image"
                          v-if="item.positionPic"
                          @click="openGoogleMap(item)"
                          style="cursor: pointer;"
                      />
                    </div>
                    <div class="other-info" v-if="item.altitude || item.temperature || item.humidity || item.batteryPercentage">
                      <div v-if="item.altitude" class="info-item">
                        <div class="info-label">
                          <img src="../../assets/altitude.png" class="info-icon"/>
                          <span class="info-text">Altitude</span>
                        </div>
                        <div class="info-value">{{ item.altitude }}</div>
                      </div>
                      <div v-if="item.temperature" class="info-item">
                        <div class="info-label">
                          <img src="../../assets/temperature.png" class="info-icon"/>
                          <span class="info-text">Temperature</span>
                        </div>
                        <div class="info-value">{{ item.temperature }}</div>
                      </div>
                      <div v-if="item.humidity" class="info-item">
                        <div class="info-label">
                          <img src="../../assets/humidity.png" class="info-icon"/>
                          <span class="info-text">Humidity</span>
                        </div>
                        <div class="info-value">{{ item.humidity }}</div>
                      </div>
                      <div v-if="item.batteryPercentage" class="info-item">
                        <div class="info-label">
                          <img src="../../assets/battery_percentage.png" class="info-icon"/>
                          <span class="info-text">Battery</span>
                        </div>
                        <div class="info-value">{{ item.batteryPercentage }}</div>
                      </div>
                    </div>
                    <div v-if="item.picString" class="image-message">
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="item.picString"
                        fit="cover"  :preview-src-list="[item.picString]"></el-image>
                    </div>
                     <div v-if="item.voiceString" class="voice-message" @click.stop="toggleVoice(item)">
                        <div v-if="failedMessages.includes(item.id)" class="voice-error">
                          <div class="error-content">
                            <span class="error-text">the file is damaged</span>
                          </div>
                        </div>
                        <div v-else class="voice-player voice-player-right" :class="{ 'playing': currentPlayingId === item.id && isPlaying }">
                          <div class="voice-content">
                            <span class="voice-text">voice message</span>
                          </div>
                           <div class="voice-icon">
                            <div class="voice-wave">
                              <span class="wave-bar" v-for="i in 3" :key="i" :class="{ 'active': currentPlayingId === item.id && isPlaying }"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="wechat-avatar">{{ item.sendNickName.split('')[0] }}</div>
                <div class="user-name user-name-right">{{ item.sendNickName }}</div>
              </div>
            </div>
            <div
                v-if="!item.isRight"
                @click="clickItem(item)"
                style="text-align: left"
            >
              <div class="message-wrapper">
                <div class="user-name">{{ item.recipientNickName }}</div>
                <div class="wechat-avatar">{{ item.recipientNickName.split('')[0] }}</div>
                <div class="message-content-wrapper">
                  <div class="message-content">
                    <div v-if="item.msg" class="wechat-bubble">{{ item.msg }}</div>
                    <div v-if="item.sos">
                      <img src="../../assets/sos.jpeg" class="sosleft"/>
                    </div>
                    <div v-if="item.positionPic">
                      <img :src="item.positionPic" class="position-image" @click="openGoogleMap(item)" style="cursor: pointer;"/>
                    </div>
                    <div class="other-info" v-if="item.altitude || item.temperature || item.humidity || item.batteryPercentage">
                      <div v-if="item.altitude" class="info-item">
                        <div class="info-label">
                          <img src="../../assets/altitude.png" class="info-icon"/>
                          <span class="info-text">Altitude</span>
                        </div>
                        <div class="info-value">{{ item.altitude }}</div>
                      </div>
                      <div v-if="item.temperature" class="info-item">
                        <div class="info-label">
                          <img src="../../assets/temperature.png" class="info-icon"/>
                          <span class="info-text">Temperature</span>
                        </div>
                        <div class="info-value">{{ item.temperature }}</div>
                      </div>
                      <div v-if="item.humidity" class="info-item">
                        <div class="info-label">
                          <img src="../../assets/humidity.png" class="info-icon"/>
                          <span class="info-text">Humidity</span>
                        </div>
                        <div class="info-value">{{ item.humidity }}</div>
                      </div>
                      <div v-if="item.batteryPercentage" class="info-item">
                        <div class="info-label">
                          <img src="../../assets/battery_percentage.png" class="info-icon"/>
                          <span class="info-text">Battery</span>
                        </div>
                        <div class="info-value">{{ item.batteryPercentage }}</div>
                      </div>
                    </div>
                    <div v-if="item.picString" class="image-message">
                      <el-image
                        style="width: 150px; height: 150px"
                        :src="item.picString"
                        fit="cover"  :preview-src-list="[item.picString]"></el-image>
                    </div>
                    <div v-if="item.voiceString" class="voice-message" @click.stop="toggleVoice(item)">
                        <div v-if="failedMessages.includes(item.id)" class="voice-error">
                          <div class="error-content">
                            <span class="error-text">the file is damaged</span>
                          </div>
                        </div>
                        <div v-else class="voice-player" :class="{ 'playing': currentPlayingId === item.id && isPlaying }">
                          <div class="voice-icon">
                            <div class="voice-wave">
                              <span class="wave-bar" v-for="i in 3" :key="i" :class="{ 'active': currentPlayingId === item.id && isPlaying }"></span>
                            </div>
                          </div>
                          <div class="voice-content">
                            <span class="voice-text">voice message</span>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 26px;"></div>
        </div>
      </div>

      <div class="msgbox">
        <div class="input-with-counter">
          <el-input v-model="news" type="textarea" :autosize="{ minRows: 1, maxRows: 6 }" placeholder="Type your message here" @input="handleInput" />
          <div class="byte-counter">{{ currentByteLength }}/110</div>
        </div>
        <el-button size="small" @click="submit" :disabled="!news || isInCooldown" :class="['custom-send-button', { 'cooldown': isInCooldown }]">{{isInCooldown?'sending':'send'}}</el-button>
      </div>
<!--      <footer class="footer">-->
<!--      <a class="link" href="https://beian.miit.gov.cn" target="_blank">沪ICP备2024082659号-3</a>-->
<!--      </footer>-->
    </el-card>

  </div>
  </div>

</template>

<script>
import {querySmsLinkRecordByCode, replySmsLinkByCode} from '../../api/apis'
import moment from 'moment'
import { debounce } from 'lodash-es';
import {read} from '../../storage/session'
export default {
  data() {
    return {
      words: '',
      msg: [],
      originmsg: [],
      loading: false,
      news: '',
      smsId: '',
      sec: 30,
      timer: null,
      currentPlayingId: null,
      isPlaying: false,
      audioPlayer: null,
      failedMessages: [],
      interval: Number(localStorage.getItem('interval')|| 10000) , // 默认3秒冷却时间
      isInCooldown: false,
      cooldownTimer: null
    }
  },
  computed: {
    // 计算当前内容的字节长度
    currentByteLength() {
      if (!this.news) return 0;
      // 使用TextEncoder计算UTF-8字节长度
      const encoder = new TextEncoder();
      const bytes = encoder.encode(this.news);
      return bytes.length;
    }
  },
  created() {
    this.getVerificationCode()
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.cooldownTimer) {
      clearTimeout(this.cooldownTimer)
      this.cooldownTimer = null
    }
    if (this.audioPlayer) {
      this.audioPlayer.pause()
      this.audioPlayer = null
    }
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        this.sec--
        if (this.sec <= 0) {
          this.sec = 30 // 重置为30秒
          this.getVerificationCode()
        }
      }, 1000)
    },
    async getVerificationCode() {
      let thiz = this
      const res = await querySmsLinkRecordByCode({})
      if (res.success) {
        this.msg = []
        this.originmsg = []
        for (let d of res.data) {
          let parse = JSON.parse(d.smsContent)
          console.log(parse)
          let msgBody = {
            id: d.id || Date.now() + '_' + index,
            time: moment(d.createTime).utcOffset(8).format('YYYY-MM-DD HH:mm:ss [UTC+08:00]'),
              msg: parse.text,
              sendNickName: read('nickName') ? read('nickName').charAt(0).toUpperCase() + read('nickName').slice(1) : 'Undefined',
              recipientNickName: read('otherNickName') ? read('otherNickName').charAt(0).toUpperCase() + read('otherNickName').slice(1) : 'Undefined',
              isRight: d.senderNumber === read('number'),
              altitude: parse.altitude,
              batteryPercentage: parse.batteryPercentage,
              humidity: parse.humidity,
              temperature: parse.temperature,
              sos: parse.sos,
              longitudeAndLatitude: parse.longitudeAndLatitude
            }

            if (parse.positionPic) {
              msgBody.positionPic = 'data:image/png;base64,' + parse.positionPic
            }
            if (parse.voiceString) {
              msgBody.voiceString = 'data:audio/wav;base64,' + parse.voiceString
            }
            if(parse.picString){
              msgBody.picString = 'data:image/png;base64,' + parse.picString
            }

            thiz.msg.push(msgBody)
            thiz.originmsg = thiz.msg
            if (res.data.length > 0) {
              this.smsId = res.data[res.data.length - 1].id
            }
          }
      }
    },

    clickItem(item) {
      this.smsId = item.id
    },
    // 处理输入事件，限制字节长度
    handleInput() {
      const MAX_BYTES = 110;
      const encoder = new TextEncoder();

      // 如果当前内容已经超过限制，需要截断
      while (this.news && encoder.encode(this.news).length > MAX_BYTES) {
        // 从末尾截断一个字符
        this.news = this.news.slice(0, -1);
      }
    },

    submit: debounce(function () {
      if (!this.news) {
        this.$message.error('Please enter a message')
        return
      }
      if (this.isInCooldown) {
        this.$message.error('Message sending, please try again later.')
        return
      }

        // 设置按钮进入冷却状态
        this.isInCooldown = true;
        // 设置冷却定时器，在interval时间后恢复
        if (this.cooldownTimer) {
          clearTimeout(this.cooldownTimer);
        }
        this.cooldownTimer = setTimeout(() => {
          this.isInCooldown = false;
        }, this.interval);
      replySmsLinkByCode({text: this.news}).then(async (res) => {
        if (res.success) {
          this.news = ''
          await this.getVerificationCode()
          this.$nextTick(() => {
            // 调用滚动方法滚动到底部
            this.$refs.msgcontainerInnser.scrollTop = this.$refs.msgcontainerInnser.scrollHeight
          })
        }
      }).catch(e=>{
        console.error(e)
        // 设置按钮进入冷却状态
        this.isInCooldown = false;
        // 设置冷却定时器，在interval时间后恢复
        if (this.cooldownTimer) {
          clearTimeout(this.cooldownTimer);
        }
      })
    }, 1000,
    {leading: true}),
    filterWords() {
      if (!this.words) {
        this.msg = this.originmsg
        return
      } else {
        this.msg = this.originmsg.filter((item) =>
            item.msg.startsWith(this.words)
        )
      }
    },
    toggleVoice: debounce(function (item) {
      if (!item.voiceString) return;

      // 如果点击的是当前正在播放的语音，则切换播放/暂停
      if (this.currentPlayingId === item.id) {
        if (this.isPlaying) {
          this.pauseVoice();
        } else {
          this.resumeVoice();
        }
        return;
      }

      // 停止当前播放的语音
      this.stopVoice();

      // 播放新的语音
      this.playVoice(item);
    }, 300),
    playVoice(item) {
      if (this.currentPlayingId === item.id && this.isPlaying) {
        return;
      }
      if (this.audioPlayer) {
        this.audioPlayer.pause();
        this.audioPlayer = null;
      }

      this.audioPlayer = new Audio(item.voiceString);
      this.currentPlayingId = item.id;
      this.isPlaying = true;

      // 监听播放结束事件
      this.audioPlayer.addEventListener('ended', () => {
        this.onVoiceEnded();
      });

      // 监听错误事件
      this.audioPlayer.addEventListener('error', (e) => {
        console.error('voice playback error:', e);
        this.markAsFailed(item.id);
        this.stopVoice();
      });

      this.audioPlayer.play().catch(err => {
        console.error('playback failed:', err);
        this.markAsFailed(item.id);
        this.stopVoice();
      });
    },
    pauseVoice() {
      if (this.audioPlayer && this.isPlaying) {
        this.audioPlayer.pause();
        this.isPlaying = false;
      }
    },
    resumeVoice() {
      if (this.audioPlayer && !this.isPlaying) {
        this.audioPlayer.play().catch(err => {
          console.error('recovery playback failed:', err);
          this.stopVoice();
        });
        this.isPlaying = true;
      }
    },
    stopVoice() {
      if (this.audioPlayer) {
        this.audioPlayer.pause();
        this.audioPlayer = null;
      }
      this.currentPlayingId = null;
      this.isPlaying = false;
    },
    onVoiceEnded() {
      // 播放结束，重置播放状态
      this.stopVoice();
    },
    markAsFailed(messageId) {
      if (!this.failedMessages.includes(messageId)) {
        this.failedMessages.push(messageId);
      }
    },

    // 打开谷歌地图
    openGoogleMap(item) {
      // 经纬度信息在longitudeAndLatitude字段中用逗号分隔
      if (item.longitudeAndLatitude) {
        // 分割经纬度字符串
        const [longitude, latitude] = item.longitudeAndLatitude.split(',');

        if (longitude && latitude) {
          // 注意谷歌地图的查询参数格式是 纬度,经度
          const mapUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
          window.open(mapUrl, '_blank');
        } else {
          // If latitude and longitude format is incorrect, show user tip
          this.$message.info('Invalid latitude and longitude format');
        }
      } else {
        // If no latitude and longitude information, show user tip
        this.$message.info('No latitude and longitude information available for this location');
      }
    }
  }
}
</script>
<style lang="less" scoped>
.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-position: 100%;
  background-image: url('../../assets/login-bg.jpg');
}

h1 {
  position: relative;
  margin: 0 0 1rem;
  z-index: 1;
  color: #eeeeee;
}

.login-wrapper {
  margin-top: 10%;
}

.login-button {
  width: 100%;
}

.msgbox {
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  flex-shrink: 0;
  column-gap: 10px;
  align-items: flex-end;

  .input-with-counter {
    flex: 1;
    position: relative;
    display: flex;
  }

  .byte-counter {
    position: absolute;
    bottom: 5px;
    right: 10px;
    font-size: 12px;
    color: #909399;
    background: #fff;
    padding: 0 5px;
    z-index: 1;
  }
  /deep/ .el-textarea__inner{
    padding-right: 52px;
  }

  /deep/ .el-input {
    width: 85%;
    margin-bottom: 5px; // 增加底部空间避免内容被遮挡

    textarea {
      resize: none;
      min-height: 30px;
      line-height: 1.5;
      padding-bottom: 15px; // 增加输入框底部内边距避免内容被遮挡
    }
  }

  // 自定义发送按钮样式
  .custom-send-button {
    background-color: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 6px 15px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    height: 32px;
    align-self: flex-end;

    &:hover:not(:disabled) {
      background-color: #66b1ff;
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
      box-shadow: 0 1px 3px rgba(64, 158, 255, 0.3);
    }

    &:disabled {
      background-color: #c0c4cc;
      cursor: not-allowed;
      opacity: 0.6;
    }

    // 冷却状态的按钮样式 - 使用#409eff的浅色版本
    &.cooldown {
      opacity: 0.8;
      background-color: #73bbff !important;
      border-color: #73bbff !important;
      cursor: not-allowed;
    }
  }
}

.container {
  position: fixed;
  inset: 0;
}

.elrow {
  width: 430px;
  padding: 30px;
  margin: auto;
  position: relative;
  height: 100%;
  box-sizing: border-box;
}
.card-box {
  height: 100%;

}
/deep/ .el-card__body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.time {
  font-size: 13px;
  color: #4769c8;
  height: 10px;
  width: 100%;
  z-index: 9999;
  background: #fff;
  text-align: center;
  height: 40px;
  line-height: 40px;
  // width: calc(100% - 32px);
  display: flex;
  justify-content: space-around;
  margin: 10px 0;

  span {
    flex: 1;
    text-align: center;
    padding-right: 30px;
  }
}

.msgcontainer {
  width: 100%;
  flex: 1;
  overflow: hidden;
}
.msgcontainer-inner {
  height: 100%;
  padding-top: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

/deep/ .el-card__body {
  padding: 0 !important;
}

//.msgbox {
//  flex-shrink: 0;
//  /deep/ .el-input {
//    width: 85%;
//
//    input {
//      width: 85%;
//      line-height: 30px;
//      height: 30px;
//    }
//  }
//}

.message-wrapper {
  display: flex;
  align-items: flex-start;
  max-width: 100%;
  margin: 10px 0;
  position: relative;
  padding-top: 15px;
}
.user-name {
  font-size: 12px;
  color: #787C88;
  position: absolute;
  top: 10px;
  left: 50px;
}
.user-name-right  {
  right: 50px;
  left: auto;
}
.message-wrapper-right {
  justify-content: flex-end;
  .wechat-bubble {
    background-color: #DEF8E8;
    text-align: left;
  }
  .user-name-right {
    color: #787C88;
  }
  .wechat-avatar {
    background-color: #E7E6EB;
  }
  .voice-player {
    background-color: #DEF8E8;
  }
  .other-info {
    background: #DEF8E8;
  }
}

.wechat-container {
  display: flex;
  max-width: 100%;
  margin: 10px 0;
}

.wechat-left {
  justify-content: flex-start;
}

.wechat-right {
  justify-content: flex-end;
}

.message-content-wrapper {
  display: flex;
  flex-direction: column;
  width: 70%;
  padding-top: 12px;
}
.message-content-wrapper-right {
  align-items: flex-end;
}

.message-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: flex-start;
}

.message-content-wrapper-right .message-content {
  align-items: flex-end;
}

.wechat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 8px;
  object-fit: cover;
  // background-color: #ddd;
  flex-shrink: 0;
  text-align: center;
  color: #757A7D;
  line-height: 40px;
  font-size: 18px;
  box-sizing: border-box;
  background-color: #E7E6EB;
}

.user-name {

}

.wechat-bubble {
  padding: 10px 14px;
  border-radius: 18px;
  font-size: 16px;
  line-height: 1.5;
  word-break: break-all;
  white-space: pre-wrap;
  position: relative;
  box-shadow: 0 0px 1px rgba(0, 0, 0, 0.2);
  max-width: 100%;
}

.other-info {
  width: 180px;
  font-size: 14px;
  padding: 12px;
  background-color: rgba(240, 240, 240, 0.5);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 80px;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
}

.info-icon {
  width: 16px;
  height: 16px;
}

.info-text {
  font-size: 12px;
  color: #666;
}

.info-value {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.wechat-left .wechat-bubble {
  background-color: #ffffff;
  color: #000;
}

.wechat-left .wechat-bubble:after {
  content: '';
  position: absolute;
  left: -6px;
  top: 12px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-right-color: #ffffff;
}

.wechat-right .wechat-bubble {
  background-color: #ffffff;
  color: #000;
}

.wechat-right .wechat-bubble:after {
  content: '';
  position: absolute;
  right: -6px;
  top: 12px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-left-color: #ffffff;
}

@media (max-width: 480px) {
  .wechat-bubble {
    max-width: 100%;
    font-size: 14px;
  }

  .wechat-avatar {
    width: 36px;
    height: 36px;
  }
}

.top {
  display: flex;
  color: #ffffff;
  font-size: 12px;
  background-color: #3C81F6;
  justify-content: center;
  align-items: center;
  padding: 10px;
  .top-inner{
    text-align: left;
    display: flex;
    flex-direction: column;
    row-gap: 4px;
  }
}

.words {
  width: 150px;
  height: 30px;

  /deep/ .el-input__inner {
    line-height: 30px;
    height: 30px;
    //  width: 70%;
  }
}

img {
  max-width: 100%;
  height: auto;
}

/* 这些样式被新的 .other-info 样式替代 */

.sosright {
  width: 30px;
  margin-bottom: 8px;
}

.sosleft {
  width: 30px;
  margin-bottom: 8px;
}

.position-image {
  width: 60%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.voice-message {
  margin: 10px 0;
  cursor: pointer;
}
.right-message {
  display: flex;
  justify-content: flex-end;
}

.voice-player {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #F3F4F6;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: 200px;
  transition: all 0.3s ease;
}

.voice-player:hover {
  background-color: #f5f5f5;
}

.voice-player.playing {
  background-color: #e3f2fd;
}



.voice-icon {
  margin-right: 8px;
}

.voice-wave {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 20px;
}

.wave-bar {
  width: 3px;
  height: 12px;
  background-color: #95a5a6;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.voice-player-right .voice-icon {
  margin-left: 8px;
  margin-right: 0;
}



.wave-bar:nth-child(1) {
  animation-delay: 0s;
}

.wave-bar:nth-child(2) {
  animation-delay: 0.1s;
}

.wave-bar:nth-child(3) {
  animation-delay: 0.2s;
}

.wave-bar.active {
  background-color: #3498db;
  animation: wave-animation 1.5s ease-in-out infinite;
}

@keyframes wave-animation {
  0%, 100% {
    height: 12px;
  }
  50% {
    height: 20px;
  }
}


.voice-content {
  flex: 1;
}

.voice-text {
  font-size: 14px;
  color: #2c3e50;
}

.voice-player.playing .voice-text {
  color: #3498db;
}

.voice-error {
  margin: 10px 0;
  cursor: default;
}

.voice-error .error-content {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #ffebee;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.error-text {
  font-size: 14px;
  color: #f44336;
  font-weight: 500;
}

.footer {
  padding-bottom: 10px;
  .link {
    font-size: 12px;
    text-decoration: none;
    color: #000000;
  }
}

@media (max-width: 768px) {
  .elrow {
    width: 100%;
    padding: 0;
  }
}

</style>
